import { render, staticRenderFns } from "./french_onetoone_appointment.vue?vue&type=template&id=17f6081c&scoped=true"
import script from "./french_onetoone_appointment.vue?vue&type=script&lang=js"
export * from "./french_onetoone_appointment.vue?vue&type=script&lang=js"
import style0 from "./french_onetoone_appointment.vue?vue&type=style&index=0&id=17f6081c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f6081c",
  null
  
)

export default component.exports